module.exports = __webpack_public_path__ + "img/UserValidSettings.7de819dc.svg";